import { PermissionTypes } from 'features/permissions/types';
import { PermissionsCheckMode } from 'features/permissions/utils/checkPermissions';

export interface LookupDynamicPermissionOptions {
  permission: PermissionTypes | PermissionTypes[];
  dynamicPermissions?: PermissionTypes[];
  mode?: PermissionsCheckMode;
}

export const lookupDynamicPermission = (options: LookupDynamicPermissionOptions) => {
  const { permission, dynamicPermissions, mode = 'any' } = options;

  if (!dynamicPermissions) {
    return false;
  }

  if (Array.isArray(permission)) {
    return mode === 'any'
      ? permission.some((p) => dynamicPermissions.includes(p))
      : permission.every((p) => dynamicPermissions.includes(p));
  }

  return dynamicPermissions.includes(permission);
};
